
import {  AfterViewInit, Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { DataTableDirective } from 'angular-datatables';
import { formatDate, NgIfContext } from '@angular/common';
import { NgxSpinnerService } from 'ngx-spinner';
import { Subject } from 'rxjs';
import { ApiServiceProject } from 'src/app/web/apis/ApiServiceProject';
import { FormatDataTableGlobal, FormatDataTableGlobalFive } from 'src/app/web/util/formatDataTable';
import { payTemplate } from 'src/app/web/interfaces/project/payments/payments';
import Swal from 'sweetalert2';
import { ErrorService } from 'src/app/shared/services/errors.service';
export function FormatterPeso(): any {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 2
    })
}

export function FormatterDolar(): any {
    return new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })
}

export function FormatterPesonNotDecimal(): any {
    return new Intl.NumberFormat('es-CL', {
        style: 'currency',
        currency: 'CLP',
        minimumFractionDigits: 0
    })
}
@Component({
  selector: 'app-multiplespagos',
  templateUrl: './multiplespagos.component.html',
  styleUrls: ['./multiplespagos.component.scss']
})
export class PayMultiplesComponent implements  AfterViewInit, OnDestroy, OnInit  {
  @Input() pagos:payTemplate
  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtTrigger = new Subject();
  paymentsform: FormGroup;
  fechasForm: FormGroup;
  dtOptions: DataTables.Settings = {dom:'1.5'};
  idProject
  nameproject
  tipomoneda
  listtype : [{id:number,
               name:string}];
  listapagos:[{description:string,monto:string}];

  items!: FormArray;  

  constructor(
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private router: Router,
    private route: ActivatedRoute,
    private apiService: ApiServiceProject,
    private errorService:ErrorService
  ) { 
    this.route.params.subscribe((params) => {
      this.idProject = params['id'];
      this.nameproject = params['name'];

    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.dtOptions = FormatDataTableGlobalFive();
    this.paymentsform = this.fb.group({
      items: new FormArray([])  
    });
    this.selectMoneda()
     for(let i = 0 ; i < this.pagos.listPlay.length; i++){
    
      this.items = this.paymentsform.get('items') as FormArray;  
      let pago = this.pagos.listPlay[i].monto
       pago = pago.replace('$','')
       pago = pago.split(".").join('')
       pago = pago.split(",").join('.')
      
      let info = this.fb.group({  
        
          title: this.pagos.listPlay[i].description,
          pay_amount:this.tipomoneda.format(pago),
          amount_percent: 0,
          scheduled_date:''
        
      });  

      this.items.push(info);
    }

    this.listapagos = this.pagos.listPlay 
    this.rerender()
    this.spinner.hide();
  }
    selectMoneda(){
      if(this.pagos.playOptionDescription != 'CLP' && this.pagos.playOptionDescription != 'Paraguayo') {
        this.tipomoneda = FormatterPeso()
      }
      else
      {
        this.tipomoneda = FormatterPesonNotDecimal()
      }
    }
  nuevoPago(){
    let info = this.fb.group({ 
          title: "",
          pay_amount: 0,
          amount_percent: 0,
          scheduled_date:''
        
      });  

      this.items.push(info);
      this.total()
  }

 async validate(info){
  const { value: text } = await Swal.fire({
  icon:'warning',
  text:'Si esta seguro de esta accion, ingrese una descripcion de cierre y luego presione el botoon aceptar',
  input: 'textarea',
  inputLabel: 'Message',
  inputPlaceholder: 'Type your message here...',
  inputAttributes: {
    'aria-label': 'Type your message here'
  },
  showCancelButton: true,
  heightAuto: false
})

if (text) {
  Swal.fire(text)
} }
  get form() {
    return this.paymentsform.controls;
  }
  deletePay(index){
    this.items.removeAt(index)
    this.total()
  }
  porcentaje(e: Event ,inx){
    const element = e.target as HTMLInputElement
    this.total()

    let info = element.value+"";
    info = info.replace('$','')
    info = info.split(".").join('')
    info = info.split(",").join('.')
    element.value = this.tipomoneda.format(info) 
  }

  total(){
    let montito = this.pagos.monto
        montito = montito.replace('$','')
        montito = montito.split(".").join('')
        montito = montito.split(",").join('.')
    let suma = 0

    this.items.value.map((d)=>{
      if(d.pay_amount == this.items.value[0].pay_amount){
        suma = suma + Number(montito);
      }else{
        let info = d.pay_amount+"";
        info = info.replace('$','')
        info = info.split(".").join('')
        info = info.split(",").join('.')

        suma = suma + Number(info);
      }
    })

    let res
    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    res = (Number(montito)*2)  - Number(suma)
    
    if(res < 1){ 
      res = 0
     form.classList.add('was-validated');
    this.items.value[0].pay_amount = this.tipomoneda.format(res)
  }else{
      form.classList.remove('was-validated');
      this.items.value[0].pay_amount = this.tipomoneda.format(res)
    }
    
   
  }
  formSubmit(){

    var form = document.getElementsByClassName('needs-validation')[0] as HTMLFormElement;
    if (form.checkValidity() === false) {
      form.classList.add('was-validated');
    } else {
      this.btnGuardar()
    }

  
  }
 btnGuardar(){
    this.spinner.show()
    let array = []
    this.items.value.map((d)=>{
        d.pay_amount = d.pay_amount.replace('$','')
        d.pay_amount = d.pay_amount.split(".").join('')
         d.pay_amount = d.pay_amount.split(",").join('.')
      let realStartDateDay =
                d.scheduled_date.split('-')[2];
              let realStartDateMonth =
                d.scheduled_date.split('-')[1];
              let realStartDateYear =
                d.scheduled_date.split('-')[0];
              let realStartDate =
                realStartDateDay +
                '-' +
                realStartDateMonth +
                '-' +
                realStartDateYear;
                let pago=d.pay_amount;
                pago = this.tipomoneda.format(pago)
                pago = pago.replace('$','')
                

      array.push({
        title: d.title,
        pay_amount: pago,
        amount_percent: 0,
        scheduled_date: realStartDate
      })
    })
     let post = {
       pay_amount_total:this.pagos.monto,
       projects_id : Number(this.idProject),
       project_attachments_id :0,
       money_type_id:Number(this.pagos.play_option_id),
       templete_id:Number(this.pagos.templete_id),
       listProjectPlayInfo:array
     }
     this.apiService
         .postService('project-play-create', post)
         .subscribe({
           next: (rs: any) => {
            if(rs.code){
               this.spinner.hide();
               Swal.fire({title:rs.error,text: '',icon: 'error',heightAuto: false});
             }
             else{
               this.spinner.hide();
               this.spinner.hide()
               Swal.fire({title:rs.message,text: '',icon: 'success',heightAuto: false}).then(()=>{
                this.router.navigate([`/pdg/project/pay/list/${this.idProject}/${this.nameproject}`]);
               });
           }
           },
           error: (error) => {
             this.errorService.error(error);
           },
         });
    
  }




   ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    
  }
}
